import { render, staticRenderFns } from "./ScreensSidebar.vue?vue&type=template&id=35d3950d&scoped=true"
import script from "./ScreensSidebar.vue?vue&type=script&lang=js"
export * from "./ScreensSidebar.vue?vue&type=script&lang=js"
import style0 from "./ScreensSidebar.vue?vue&type=style&index=0&id=35d3950d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d3950d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35d3950d')) {
      api.createRecord('35d3950d', component.options)
    } else {
      api.reload('35d3950d', component.options)
    }
    module.hot.accept("./ScreensSidebar.vue?vue&type=template&id=35d3950d&scoped=true", function () {
      api.rerender('35d3950d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screens/ScreensSidebar.vue"
export default component.exports